<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      {{ title }}
    </div>


    <div class="mt-15 pl-4 pr-4 container">
      <BrandProgress class="mt-6" :step="step"/>
      <router-view class="mt-3"/>
    </div>

  </div>
</template>


<script>
import BrandProgress from "@/components/customization/BrandProgress.vue";
import bus from "@/util/EventBus";
import log from "@/util/log";
import PopupBrandInfo from "@/components/customization/PopupBrandInfo.vue";

export default {
  name: "Customization",
  components: { PopupBrandInfo, BrandProgress },
  data() {
    return {

      step: 0

    };
  },
  methods: {
    onClickHeaderReturn() {
      this.$router.back();
    },
    onStepChange(step) {
      log(`step = ${step}`);
      this.step = step;
      switch (step) {

      }
    }
  },
  computed: {
    title() {
      switch (this.step) {
        case 0:
          return 'Brand'
        case 1:
          return 'Product'
        case 2:
          return 'Flavor'
        case 3:
          return 'Write Data'
      }
    }
  },
  mounted() {
    bus.$on("stepChange", this.onStepChange);
  },
  created() {
    log(`created`);
  },
  destroyed() {
    bus.$off("stepChange", this.onStepChange);
  }
};
</script>

<style scoped lang="less">

</style>